/** Whether a secret company setting is set; the value itself never reaches the browser. */
export type SecretStatus = {
    set: boolean;
    /** e.g. "••••1234", or null when not set. */
    hint: string | null;
};

/** The secret settings the backend knows about (CompanySecret on the server). */
export type CompanySecretKey = "geocodingToken";
export const COMPANY_SECRET_KEYS: CompanySecretKey[] = ["geocodingToken"];

type CompanySetting = {
    id: number;
    name: string;
    /** Public Mapbox browser token (pk.…); restrict it to your domain in Mapbox. */
    mapboxToken: string;
    secrets: Partial<Record<CompanySecretKey, SecretStatus>>;
};

export default CompanySetting;
